import { render, staticRenderFns } from "./ProofreadingPreviewPlan.vue?vue&type=template&id=23a6b240&scoped=true"
import script from "./ProofreadingPreviewPlan.vue?vue&type=script&lang=ts"
export * from "./ProofreadingPreviewPlan.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingPreviewPlan.vue?vue&type=style&index=0&id=23a6b240&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a6b240",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23a6b240')) {
      api.createRecord('23a6b240', component.options)
    } else {
      api.reload('23a6b240', component.options)
    }
    module.hot.accept("./ProofreadingPreviewPlan.vue?vue&type=template&id=23a6b240&scoped=true", function () {
      api.rerender('23a6b240', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/proofreading/ProofreadingPreviewPlan.vue"
export default component.exports